import { useIonRouter } from '@ionic/vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/store.user';
import { isPlatform } from '@ionic/vue';
import userApi from '@/api/user';
import { showAlert } from '@/helpers/alertHelper';
import { showLoading,hideLoading } from '@/helpers/loadingHelper';
import { nextTick } from 'vue';


export const useUser = () => {  

    const ionRouter = useIonRouter();
    const userStore = useUserStore();
    const { isMobile, view, username, password,rememberMe, userData } = storeToRefs(userStore);

    const setViewTittle = (dataview:string) => {
       view.value = dataview;
    }

    const makeLogin = async () => {
        showLoading('Ingresando...');
        userApi.login(username.value, password.value).then(async (dataUser) => {
                        
            await userStore.saveToken(dataUser.access_token, dataUser.expires_in);
            await userStore.set(dataUser.profile);

            userData.value = dataUser.profile;
            
            await userStore.setRememberMe(rememberMe.value);
                                
            // Proper async flow
            checkMobile();

            await nextTick();
            if(userData.value?.first_access) {
                ionRouter.push('/first-access');
            }
            setTimeout(()=>{
                if(isMobile.value){
                    ionRouter.push('/explotaciones');
                }else{
                    window.location.reload();
                }
            },500);
            hideLoading();
        }).catch(errorData => {
            console.log(errorData);
            hideLoading();
            const message = errorData.response?errorData.response.data.message:'Ocurrio un error al ingresar intente mas tarde';
            showAlert('Error',message);
        });

    };

    const makeLogout = async () => {
        showLoading('Cerrando sesion...')
        await userApi.logout();
        
        // remove user
        await userStore.clear();
        hideLoading();
        //reload
        window.location.reload();
    }

    /* recovery password */
    const recoveryPassword = async (dniOrCif:string) => {

        await userApi.recoveryPassword(dniOrCif).then((resp) => {

            showAlert('Exito',resp);            

        }).catch(errorData => {
            
            const message = errorData.response?errorData.response.data.message:'Ocurrio un error al ingresar intente mas tarde';
            showAlert('Error',message);
                
        });
    };

    const checkMobile = () => {

        isMobile.value =  (isPlatform('ios') || isPlatform('iphone') || isPlatform('android')) && !isPlatform('mobileweb')
    };

    const checkIsValidSession = async () => {
        const tokenUser = await userStore.getToken;
        return tokenUser;
    }

    const acceptTermsAndConditions = async (data:object) => {
        try {
            const userDataStorage = await userStore.getUserData;

            const id = userDataStorage?.id;
            const userValidate = await userApi.validateFirstAccess(id,data);
            showAlert('Exito','Su usuario esta habilitado');
    
            userStore.set(userValidate);
            userData.value = userValidate.profile;
            ionRouter.push('/explotaciones');
        } catch (error) {
            console.error(error);
            showAlert('Error','Disculpe, ocurrio un error al validar su usuario');
        }
    }

    const updatePassword = async (newPassword: string, newPasswordVerification: string) => {
        try {

            if(newPassword !== newPasswordVerification){
                showAlert('¡Atencion!','Los password no coinciden!');
                return;
            }
    
            await userApi.updatePassword(userData.value?.id,newPassword);

            

            showAlert('Exito','Su password fue actualizado correctamente');

        } catch (error) {
            console.error(error);
            showAlert('Error','Disculpe, ocurrio un error al actualizar su password. Intente mas tarde.');
        }    
    };

    const get = async () => {
        checkMobile();
        const user = await userStore.getUserData
        return user;
    }

    const checkStoreUser = async () =>{
        const user = await userStore.getStorageUser
        return user;
    }
        
    return {
        //! Properties
        username,
        password,
        userData,
        isMobile,
        rememberMe,

        //! Methods
        get,
        makeLogin,
        makeLogout,
        recoveryPassword,
        checkIsValidSession,
        acceptTermsAndConditions,
        setViewTittle,
        updatePassword,
        checkStoreUser
    };
}